"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PERMISSION_TYPES = void 0;
var PERMISSION_TYPES = exports.PERMISSION_TYPES = ['Activities', 'Analytics', 'Categories', 'Credits', 'Credit_Types', 'Orders', 'Permissions', 'Permission_Groups', 'Posts', 'Submissions', 'Users'];